import React, { useEffect } from 'react';

import ContactForm from '../common/ContactForm';
import HeroSection from '../pages/HeroSection/HeroSection';
import { withTranslation } from 'react-i18next';
import { map } from 'lodash';

const contactByArr = [
  {
    title: 'FOOTER.CONTACT_NO_NEW',
    sub: '+56 2 3304 8632',
    image: '/images/contact/contact-telephone.svg',
  },
  {
    // title: 'CONTACT_US.EMAIL',
    // sub: 'clientes@pullmanbus.cl',
    image: '/images/contact/contact-email.svg',
    subItems: [
      // {
      //   title: 'CONTACT_US.EMAIL_ONE',
      //   sub: ' viajes@pullman.cl',
      // },
      {
        title: 'CONTACT_US.EMAIL_TWO',
        sub: ' clientes@pullmanbus.cl',
      },
    ],
  },
  {
    title: 'CONTACT_US.ADDRESS',
    sub: 'San Borja 235, Estación Central - Santiago.',
    image: '/images/contact/contact-address.svg',
  },
];

const socialMedia = [
  {
    img: '/images/contact/contact-social-media-facebookk.svg',
    link: 'https://www.facebook.com/pullman.cl/',
  },
  {
    img: '/images/contact/contact-social-media-instagram.svg',
    link: 'https://www.instagram.com/pullmanbus',
  },
  {
    img: '/images/contact/contact-social-media-linkedIn.svg',
    link: 'https://www.linkedin.com/company/pullman-bus/',
  },
];

const ContactUs = props => {
  const { t } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <div style={{ marginTop: '70px' }}>
        <HeroSection
          title="Contacto"
          description="Home / Contacto"
          heroImage="/images/contact/contact-banner.jpg"
          height="40vh"
        />
      </div>

      <div className="content-container cancel-done-section pages-contact-us ">
        <div className="pullman-section-primary-row">
          <div className="pullman-section-primary-row-main-heading black-text margin-T30">
            ¡Contáctanos!
          </div>
          <div className="pullman-section-primary-row-underline margin-B40"></div>
          <div className="contact-content-wrapper w-100 d-flex">
            <div className="w-50">
              <ContactForm t={t} />
            </div>
            <div className="w-50">
              {contactByArr.map(item => (
                <div className="contact-by-item d-flex">
                  <img src={item.image} className="contact-by-item__img" alt="" />
                  <div>
                    <strong style={{ fontWeight: 'bold' }}>{t(item.title)}</strong>
                    <span>{item.sub}</span>
                  </div>
                  <div className="subItems">
                    {item.subItems &&
                      item.subItems.map(item => {
                        return (
                          <div>
                            <strong style={{ fontWeight: 'bold' }}>{t(item.title)}</strong>
                            <span>{item.sub}</span>
                          </div>
                        );
                      })}
                  </div>
                </div>
              ))}

              <div className="social-media">
                <div className="pullman-section-primary-row-main-heading">¡Síguenos!</div>

                <div className="pullman-section-primary-row-underline margin-B15"></div>
                <div>
                  {socialMedia.map(item => (
                    <a href={item.link} target="_blank">
                      <img src={item.img} className="social-media__img" alt="" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation('common')(ContactUs);



// WEBPACK FOOTER //
// ./src/features/pages/ContactUs.js